// extracted by mini-css-extract-plugin
module.exports = {"entity":"entity_entity__AWEQ3","content":"entity_content__7lRgo","entityMenu":"entity_entityMenu__m3g7R","footer":"entity_footer__7mvpx","hover":"entity_hover__ZZX8T"};